// extracted by mini-css-extract-plugin
export default {"form":"NewsletterSubscribeForm_form__8XVXX","formInputs":"NewsletterSubscribeForm_formInputs__DlRCI","submitButton":"NewsletterSubscribeForm_submitButton__HWX77"};